import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form } from 'react-redux-form';
import { Row, Col } from 'react-bootstrap';
import { TRANSLATIONS as translation } from '../../../../../../../utils/constant.utils';
import {
    ORFSelect
    , ORFTextArea
    , ORFButton
    , OR_RRF_InputField as InputField
    , OR_RRF_Select as Select
    , ORFSearchSuggestions as SearchSuggestions
} from '../../../../../../common/forms/order-request-form.component';
import { newCircuitSubscriptionActions } from "./../../../../../../../store/external/request-reducer/order-request-reducer/wireline-request/new-circuit/new-circuit-subscription.reducer";
import { createRequestActions } from "./../../../../../../../store/external/request-reducer/create-request.reducer";

import './wireline-location-form.component.css';

class NewCircuitLocationForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showComponent: false
        }
    }

    componentDidMount() {
        this.props.getNewCircuitFormData();
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    };

    render() {
        const {
            //component props
            onClickCancel
            , nextAction
            // form
            , wirelineLocationFormA
            // reducer action
            , onCountrySelect
            , onBillingAddressSelect
            , fetchAddressByValue
        } = this.props;

        const { addressList } = this.props.createRequest;
        const { countryOptions, addressOptions } = this.props.newCircuitRequest;

        return (
            <div >
                <Form method="post" role="form"
                    model="wirelineLocationFormA"
                    onSubmit={nextAction}
                >
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <Select
                                className="form-control"
                                label={`${this.toLocaleLanguage('country')} *`}
                                value={wirelineLocationFormA.countryCode}
                                options={countryOptions}
                                placeholder={this.toLocaleLanguage('select_a_country')}
                                fieldProp='.countryCode'
                                onChangeAction={onCountrySelect}
                            //validators={requiredValidation}
                            //errorMessages={countryValidationsErrorMsgs}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <SearchSuggestions
                                value={wirelineLocationFormA.billingAddress}
                                label={`${this.toLocaleLanguage('billing_address')}`}
                                propDisplay={'LocationName'}
                                options={addressList.length > 0 ? addressList : ''}
                                onChangeAction={onBillingAddressSelect}
                                searchAction={fetchAddressByValue}
                                disabled={wirelineLocationFormA.countryCode == ''}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <Select
                                className="form-control"
                                label={`${this.toLocaleLanguage('location_address')} *`}
                                options={addressOptions}
                                placeholder={this.toLocaleLanguage('select_an_address')}
                                fieldProp='.locationAddressId'
                                value={wirelineLocationFormA.locationAddressId}
                                disabled={wirelineLocationFormA.countryCode == ''}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <InputField
                                className="form-control"
                                type="text"
                                label={`${this.toLocaleLanguage('demarc_location')}`}
                                value={wirelineLocationFormA.demarcLocation}
                                fieldProp='.demarcLocation'
                                disabled={wirelineLocationFormA.countryCode == ''}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <Select
                                className="form-control"
                                label={`${this.toLocaleLanguage('location_address_p2p')}`}
                                options={addressOptions}
                                placeholder={this.toLocaleLanguage('select_an_address')}
                                fieldProp='.locationAddressPTPId'
                                value={wirelineLocationFormA.locationAddressPTPId}
                                disabled={wirelineLocationFormA.countryCode == ''}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <InputField
                                className="form-control"
                                type="text"
                                label={`${this.toLocaleLanguage('demarc_location_ptp')}`}
                                value={wirelineLocationFormA.demarcLocationPTP}
                                fieldProp='.demarcLocationPTP'
                                disabled={wirelineLocationFormA.countryCode == ''}
                            />
                        </Col>
                    </Row>
                    <div className="request-button-continer">
                        <div className="bottom-left">
                            <ORFButton
                                label={this.toLocaleLanguage('modal_close_cancel_button')}
                                variant={"light"}
                                action={onClickCancel}
                                type="button"
                            />
                        </div>
                        <div className="bottom-right">
                            <div>
                                <ORFButton
                                    label={this.toLocaleLanguage('next_button')}
                                    variant={"primary"}
                                    type={"submit"}
                                    disabled={wirelineLocationFormA.countryCode == ''
                                        || wirelineLocationFormA.locationAddressId == 0}
                                />
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        );
    }
};

export default connect(
    state => {
        const { newCircuitRequest, createRequest, translation } = state;
        const { wirelineLocationFormA } = state.form;
        return {
            newCircuitRequest
            , wirelineLocationFormA
            , createRequest
            , ...translation,
        };
    }
    , dispatch =>
        bindActionCreators(
            Object.assign({}, newCircuitSubscriptionActions, createRequestActions),
            dispatch
        )
)(NewCircuitLocationForm);

// export class NewQuotationLocationForm extends Component {
//     constructor(props) {
//         super(props);
//     }

//     render() {
//         let countries = [
//             {
//                 "Key": "AR",
//                 "Value": "Argentina"
//             },
//             {
//                 "Key": "CN",
//                 "Value": "China"
//             },
//             {
//                 "Key": "FI",
//                 "Value": "Finland"
//             },
//             {
//                 "Key": "FR",
//                 "Value": "France"
//             },
//             {
//                 "Key": "DE",
//                 "Value": "Germany"
//             },
//             {
//                 "Key": "GT",
//                 "Value": "Guatemala"
//             },
//             {
//                 "Key": "HK",
//                 "Value": "Hong Kong"
//             },
//             {
//                 "Key": "HU",
//                 "Value": "Hungary"
//             },
//             {
//                 "Key": "IN",
//                 "Value": "India"
//             },
//             {
//                 "Key": "IE",
//                 "Value": "Ireland"
//             },
//             {
//                 "Key": "IT",
//                 "Value": "Italy"
//             },
//             {
//                 "Key": "KE",
//                 "Value": "Kenya"
//             },
//             {
//                 "Key": "MX",
//                 "Value": "Mexico"
//             },
//             {
//                 "Key": "PH",
//                 "Value": "Philippines"
//             },
//             {
//                 "Key": "PL",
//                 "Value": "Poland"
//             },
//             {
//                 "Key": "PT",
//                 "Value": "Portugal"
//             },
//             {
//                 "Key": "QA",
//                 "Value": "Qatar"
//             },
//             {
//                 "Key": "RO",
//                 "Value": "Romania"
//             },
//             {
//                 "Key": "SA",
//                 "Value": "Saudi Arabia"
//             },
//             {
//                 "Key": "SG",
//                 "Value": "Singapore"
//             },
//             {
//                 "Key": "SK",
//                 "Value": "Slovakia"
//             },
//             {
//                 "Key": "KR",
//                 "Value": "South Korea"
//             },
//             {
//                 "Key": "ES",
//                 "Value": "Spain"
//             },
//             {
//                 "Key": "TH",
//                 "Value": "Thailand"
//             },
//             {
//                 "Key": "GB",
//                 "Value": "United Kingdom"
//             }
//         ];

//         return (
//             <div >
//                 <Row>
//                     <Col xs={12} md={12} lg={12}>
//                         <ORFSelect
//                             className="form-control"
//                             label={"Country"}
//                             options={countries}
//                             placeholder={"Select a Country"}
//                             fieldName='wirelessLocationForm.country'
//                         />
//                     </Col>
//                 </Row>
//                 <Row>
//                     <Col xs={12} md={12} lg={12}>
//                         <ORFTextArea label={"Address"} />
//                     </Col>
//                 </Row>
//                 <Row>
//                     <Col xs={12} md={12} lg={12}>
//                         <ORFTextArea label={"Address 2 (P2P)"} />
//                     </Col>
//                 </Row>
//             </div>
//         );
//     }
// };
